module.exports = {"420281001":"东岳路街道","420281002":"东风路街道","420281003":"金湖街道","420281004":"罗家桥街道","420281070":"金山街道","420281100":"金牛镇","420281101":"保安镇","420281102":"灵乡镇","420281103":"金山店镇","420281104":"还地桥镇","420281105":"殷祖镇","420281107":"刘仁八镇","420281108":"陈贵镇","420281109":"大箕铺镇","420281170":"汪仁镇","420281200":"茗山乡","420281401":"东风农场管理区","420281402":"四顾闸管理处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420281.json
// module id = 1716
// module chunks = 0